import React, { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';
import axios from 'axios';
import Navigation from './Navigation';
import { API_ENDPOINTS } from '../config/api';
import { formatDate } from '../utils/date';
import './TraveloguePage.css';

const TraveloguePage = () => {
  const [tripReports, setTripReports] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  useEffect(() => {
    fetchTripReports();
  }, []);

  const fetchTripReports = async () => {
    try {
      setLoading(true);
      const response = await axios.get(API_ENDPOINTS.tripReports);
      setTripReports(response.data);
    } catch (err) {
      console.error('Error fetching trip reports:', err);
      setError('Failed to load trip reports');
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="travelogue-page">
      <Navigation />
      <div className="content">
        <header className="page-header">
          <h1>Travelogue</h1>
          <p className="subtitle">
            Field notes and observations from visits to museums, archaeological sites, 
            and collections housing Neo-Assyrian bas-reliefs.
          </p>
        </header>

        {loading ? (
          <div className="loading">Loading trip reports...</div>
        ) : error ? (
          <div className="error">{error}</div>
        ) : tripReports.length === 0 ? (
          <div className="no-results">
            <p>No trip reports yet. Check back soon!</p>
          </div>
        ) : (
          <div className="trip-reports-list">
            {tripReports.map((report) => (
              <Link 
                to={`/travelogue/${report.slug}`} 
                key={report.id} 
                className="trip-report-card"
              >
                {report.featured_image_url && (
                  <div className="card-image">
                    <img src={report.featured_image_url} alt={report.title} />
                  </div>
                )}
                <div className="card-content">
                  <div className="card-meta">
                    <span className="category">{report.category}</span>
                    {report.visit_date && (
                      <span className="date">{formatDate(report.visit_date)}</span>
                    )}
                  </div>
                  <h2>{report.title}</h2>
                  <p className="location">
                    📍 {report.location_name}
                    {report.city && `, ${report.city}`}
                    {report.country && `, ${report.country}`}
                  </p>
                  {report.summary && (
                    <p className="summary">{report.summary}</p>
                  )}
                  <div className="tags">
                    {report.tags && report.tags.slice(0, 4).map((tag, index) => (
                      <span key={index} className="tag">{tag}</span>
                    ))}
                  </div>
                </div>
              </Link>
            ))}
          </div>
        )}
      </div>

      <footer>
        <p>© 2024 Bas Relief Atlas - A Digital Archive of Neo-Assyrian Bas-Reliefs</p>
      </footer>
    </div>
  );
};

export default TraveloguePage;
